module.exports = __webpack_public_path__ + "media/images/emblems/BoscoGurin-coat_of_arms-b1918f87f99bf41407fb170dab5d60ee.svg";